module.exports = __webpack_public_path__ + "img/coupon-popup-bg.11096ae2.png";